import WFActions from "./WFActions";

export default WFActions;



// WEBPACK FOOTER //
// ./src/components/WorkFlow/WFActions/index.js